<template>
  <div>
    <table class="table table-hover table-responsive-md">
      <thead>
        <tr>
          <th>Usuário</th>
          <th>Nome do Curso</th>
          <th>Data de Compra</th>
          <th>Valor Pago</th>
          <th>Forma de Pagamento</th>
          <th>Parcelas</th>
          <th>Status</th>
          <th>Acessivel?</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <sell-item v-for="item in items.data" :key="item.id" :sell="item" />
      </tbody>
    </table>

    <pagination :data="items" :limit="2" size="small" @pagination-change-page="load"></pagination>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapGetters } from 'vuex'
import SellItem from './../../../components/teacher/Sell'

export default {
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  },
  components: {
    'sell-item': SellItem
  },
  data () {
    return {
      items: {}
    }
  },
  methods: {
    load: function (page=1) {
      Axios.post(`/teacher/my/courses/sells?page=${page}`, this.user)
        .then( res => {
          this.items = res.data
        })
        .catch( err => {
          console.error( err )
        })
    }
  },
  mounted() {
    this.load()
  }
}
</script>

<style>

</style>
